import { ENABLE_SEO_LANGUAGE_SELECTOR } from "@faire/web-api/indigofair/settings/ENABLE_SEO_LANGUAGE_SELECTOR";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingEnableSEOLanguageSelector = (): boolean =>
  getSettingValueWithoutAssignment(ENABLE_SEO_LANGUAGE_SELECTOR, false);
